// component
// @ts-nocheck
import Iconify from '../../components/Iconify';
import { SIDEBAR } from '../../utils/userPermission';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const driverConfig = [
  // {
  //   title: 'dashboard',
  //   path: '/dashboard/app',
  //   icon: getIcon('eva:pie-chart-2-fill'),
  //   isAllow: SIDEBAR.DASHBORD_MENU,
  // },
 //{
 //   title: 'User Management',
 //   path: '/dashboard/user-management',
 //   icon: getIcon('bxs:user-plus'),
 //   isAllow: SIDEBAR.USER_MGMT_MENU,
 // },
  //{
  //  title: 'Booking Verification',
  //  path: 'QR-details',
  //  icon: getIcon('ph:scan'),
  //  isAllow: SIDEBAR.SCAN_QR_MENU,
  //},
 // {
 //   title: 'Vehicle Overview',
  //  path: '/dashboard/vehicleoverview',
  //  icon: getIcon('fluent:vehicle-car-profile-20-filled'),
  //  isAllow: SIDEBAR.PARKING_SPACE_MENU,
  //},
  //{
  //  title: 'Driver Profile',
  //  path: '/dashboard/driver-details',
  //  icon: getIcon('mdi:card-account-details-outline'),
  //  isAllow: SIDEBAR.DRIVER_MENU,
 // },
  // {
  //   title: 'Parking Status',
  //   path: '/dashboard/myparkingstatus',
  //   icon: getIcon('fa-solid:parking'),
  // },
  {
    title: 'Booking Overview',
    path: '/dashboard/bookings',
    icon: getIcon('mdi:alpha-b-box'),
    isAllow: SIDEBAR.BOOKING_MENU,
  },
  //{
  //  title: 'Revenue Overview',
  //  path: '/dashboard/revenue',
  //  icon: getIcon('fa6-solid:money-check-dollar'),
  //  isAllow: SIDEBAR.REVENUE_MENU,
 // },
 // {
 //   title: 'Account Detail',
  //  path: '/dashboard/account',
 //   icon: getIcon('mdi:card-account-details'),
 //   isAllow: SIDEBAR.ACCOUNT_DETAIL_MENU,
 // },

  // {
  //   title: 'Statistics',
  //   path: '/dashboard/statistics',
  //   icon: getIcon('mdi:chart-line'),
  // },

  // {
  //   title: 'Scan booking',
  //   path: '/dashboard/scan',
  //   icon: getIcon('mdi:card-account-details'),
  // },
];

export default driverConfig;
